
import Transformer from '../../transformer'

// const getTotal = (supplies) => {
//   let total = supplies.reduce(
//     (a, b) => a + b.supply.zone_price * b.quantity,
//     0
//   )
//   return isNaN(total) ? 0 : total.toFixed(2)
// }

class ConceptTransformer extends Transformer {
  static fetch({
    id, slug, name, comment, description,
    unit_measurement: unitMeasurement, code, unit_price: unitPrice
  }) {
    return {
      id,
      name,
      slug,
      code,
      unitMeasurement,
      comment,
      description,
      unitPrice: unitPrice ? unitPrice.toFixed(2) : 0
    }
  }
}

export default ConceptTransformer
